










import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/common/Header.vue';
import Footer from '@/components/common/Footer.vue';
import CommentConfirmContent from '@/components/action_report/CommentConfirmContent.vue';

@Component({
  components: {
    Header,
    CommentConfirmContent,
    Footer,
  },
})
export default class ActionCommentConfirm extends Vue {}
